export default "__VITE_ASSET__DtvwjiR1__"